import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMaterialSymbolsHome = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="M4 21V9l8-6 8 6v12h-6v-7h-4v7z" />
  </svg>
);
const ForwardRef = forwardRef(SvgMaterialSymbolsHome);
const Memo = memo(ForwardRef);
export default Memo;
